<template>
  <div>
    <header class="basic notification-header">
      <div class="container -narrow">
        <div class="notification-header-group">
          <h1 class="heading -large no-margin">
            Notifications
          </h1>
          <div v-if="notifications.length > 0" class="button-group">
            <a href="#" class="demi" @click.prevent="markAllRead">Mark All Read</a>
            <a href="#" class="demi delete" @click.prevent="openConfirmModal">Delete All</a>
          </div>
        </div>
      </div>
    </header>

    <section class="container -narrow">
      <div v-if="notifications.length > 0" class="fb-notifications">
        <notification
          v-for="notification in notifications"
          :key="notification.id"
          class="fb-notification"
          :notification="notification"
          @delete-notification="deleteNotification"
          @set-notification-is-read="setNotificationIsRead"
        />
      </div>
      <div v-else>
        <div class="notifications-empty">
          <p class="-tight">
            No new notifications.
          </p>
        </div>
      </div>
      <div class="fb-notifications-more">
        <a
          v-if="!isLoading && showLoadMore"
          href="#"
          class="btn -link get-more-button"
          @click.prevent="getNotifications"
          >Load More Notifications</a
        >
      </div>
      <article v-if="isLoading" class="comment -placeholder">
        <i class="icon -loading" aria-hidden="true" /><span class="sr-only">Loading</span>
      </article>
    </section>

    <modal-confirm
      v-if="isModalOpen"
      heading="Delete All Notifications"
      subheading="Are you sure you want to delete all notifications?"
      button-text="Delete All"
      :handle-close-click="closeConfirmModal"
      :handle-confirm-click="deleteAllNotifications"
    />
  </div>
</template>

<script>
// @flow
import notification from './notification.vue'
import modalConfirm from 'app/components/modals/modal-confirm.vue'
import { fbAPIGet, fbAPIPost } from 'app/utils/http-api'

export default {
  components: { notification, modalConfirm },
  data() {
    return {
      notifications: Laravel.notifications,
      notificationsPageCount: Laravel.notifications.length,
      isLoading: false,
      isModalOpen: false,
    }
  },
  computed: {
    showLoadMore() {
      const perPage = 10
      // if we have the max amount perPage, then there could be more so show button
      return this.notificationsPageCount !== 0 && this.notificationsPageCount % perPage === 0
    },
  },
  methods: {
    minNotificationId() {
      if (this.notifications.length === 0) {
        return 0
      }
      return this.notifications.reduce((prev, curr) => (prev.id < curr.id ? prev : curr)).id
    },

    // gets 10 notifications that are earlier than minimum notification id
    getNotifications() {
      const minNotificationId = this.minNotificationId()

      this.isLoading = true

      fbAPIGet(
        `notification/get/${minNotificationId}`,
        res => {
          this.isLoading = false
          this.notifications = this.notifications.concat(res.body.data)
          this.notificationsPageCount = res.body.data.length
        },
        err => {
          // even after an error remove spinner
          this.isLoading = false
        },
      )
    },

    deleteNotification(notification: notification) {
      const notificationIndex = this.notifications.indexOf(notification)
      this.notifications.splice(notificationIndex, 1)

      const formData = new window.FormData()
      formData.append('notification_id', notification.id)
      fbAPIPost(`notification/delete`, formData)
    },

    setNotificationIsRead(notificationId: number, isReadState: boolean) {
      const notification = this.notifications.find(item => item.id === notificationId)

      if (!notification) {
        return
      }

      notification.is_read = isReadState

      const readUrl = isReadState ? 'read' : 'unread'
      const formData = new window.FormData()
      formData.append('notification_id', notificationId)

      // note: on error does not try to get back to previous state
      fbAPIPost(`notification/${readUrl}`, formData)
    },

    markAllRead() {
      this.notifications.forEach(notification => (notification.is_read = 1))

      // note: if error, notifications will not be marked unread
      fbAPIPost(`notification/read_all`)
    },

    openConfirmModal() {
      this.isModalOpen = true
    },

    closeConfirmModal() {
      this.isModalOpen = false
    },

    deleteAllNotifications() {
      this.notifications = []
      this.notificationsPageCount = 0
      this.isModalOpen = false

      // note: if error notifications are already gone from display
      fbAPIPost(`notification/delete_all`)
    },
  },
}
</script>
